import type { MentorProfileDraft } from "@/lib/api/mentor-profile";
import { MENTOR_INTEREST_OPTIONS } from "@/lib/mentor-profile/constants";

export type InterestImage = NonNullable<
  MentorProfileDraft["interest_images"]
>[number];

export type IndexedInterestImage = InterestImage & { index: number };

export function selectableInterests(
  interests: string[] | null | undefined,
): string[] {
  return [
    ...new Set(
      (interests ?? []).filter((interest) =>
        (MENTOR_INTEREST_OPTIONS as readonly string[]).includes(interest),
      ),
    ),
  ];
}

/**
 * The step shows one photo per selected interest. Legacy profiles can also
 * carry photos under interest names outside the current options, or up to
 * three per interest; those are returned as `legacy` so the mentor can see
 * and remove them instead of submitting them unseen.
 */
export function splitInterestPhotos(
  selected: string[],
  images: InterestImage[],
): { photos: IndexedInterestImage[]; legacy: IndexedInterestImage[] } {
  const photos: IndexedInterestImage[] = [];
  const legacy: IndexedInterestImage[] = [];
  const shown = new Set<string>();

  images.forEach((image, index) => {
    if (!image.imageUrl) return;
    if (selected.includes(image.interest) && !shown.has(image.interest)) {
      shown.add(image.interest);
      photos.push({ ...image, index });
    } else {
      legacy.push({ ...image, index });
    }
  });

  photos.sort(
    (a, b) => selected.indexOf(a.interest) - selected.indexOf(b.interest),
  );
  return { photos, legacy };
}
